import { NgClass } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  BtnType,
  HardBtnComponent,
  HardModalComponent,
  HardTranslatePipe,
} from "@hardcode-kz/ui";
import { IConfirmationDialog } from "../models/confirmation-dialog";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
  standalone: true,
  imports: [HardModalComponent, HardBtnComponent, NgClass, HardTranslatePipe],
})
export class ConfirmationDialogComponent implements OnInit {
  title?: string;
  titleIcon?: string;
  message?: string;
  messageIcon?: string;
  btnText?: string;
  btnIcon?: string;
  btnType?: BtnType;
  btnCloseText?: string;
  btnCloseIcon?: string;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private data: IConfirmationDialog,
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title || "";
    this.message = this.data?.message || "";
    this.btnText = this.data?.btnText || "base.save";
    this.btnIcon = this.data?.btnIcon || "icon-save";
    this.btnType = this.data?.btnType || "success";
    this.btnCloseText = this.data?.btnCloseText || "cancel";
    this.btnCloseIcon = this.data?.btnCloseIcon || "icon-cancel";
    this.titleIcon = this.data?.titleIcon || "";
    this.messageIcon = this.data?.messageIcon;
  }

  close(result = false): void {
    this.dialogRef.close(result);
  }
}
